<template>
  <header class="header">
    <ul class="header__list">
      <li class="header__list-item">
        <router-link @click.native="scrollToTop" to="/">
          <img src="@/assets/img/logo.png" alt="" class="header__list-icon">
        </router-link>
      </li>
      <li class="header__list-item">
        <router-link @click.native="scrollToTop" to="/" class="header__list-link">Home</router-link>
      </li>
      <li class="header__list-item">
        <router-link @click.native="scrollToTop" to="/services" class="header__list-link">Services</router-link>
      </li>
      <!--<li class="header__list-item">
        <router-link to="/about" class="header__list-link">About us</router-link>
      </li>-->
      <li class="header__list-item">
        <router-link @click.native="scrollToTop" to="/contacts" class="header__list-link">Contacts</router-link>
      </li>
    </ul>
  </header>
</template>

<script>
export default {
  name: "Header",
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 10;

  color: #000080;
  background: #fff;
  padding: 10px 0;

  text-transform: uppercase;

  &__list {
    display: flex;
    align-items: center;

    margin: 7px 0;

    list-style: none;

    &-icon {
      height: 55px;

      @media (max-width: 728px) {
        height: 25px;
      }
    }

    &-link {
      text-decoration: none;

      font-weight: 600;

      color: #000080;
    }

    &-item {
      font-size: 16px;

      &:not(:last-of-type) {
        margin-right: 50px;
      }

      @media (max-width: 728px) {
        font-size: 13px;

        &:not(:last-of-type) {
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
